import NProgress from 'nprogress'
import store from '@/store'
import UploadFileVisiteMA from '@/views/mdt/societe/societeDetails/historique-visites-medicales/recap-visites-medicales/upload-file-visites-medicales'
import ModalViewResult from '@/views/mdt/societe/societeDetails/historique-visites-medicales/recap-visites-medicales/modal-view-result'
import ModalUploadAnalyseResultat from '@/views/analyse/pending-visites-medicales/resultats/modal-importer-resultats'

export default {
  name: 'resultats',
  components: {UploadFileVisiteMA,ModalViewResult,ModalUploadAnalyseResultat},
  props: [],
  async beforeRouteEnter(to,from,next){
    NProgress.start()
    store.dispatch('getProgrammationsForTechLabo',to.params.id).then(
      async ()=>{
        next()
        NProgress.done()
      }, error =>{
        error
        next()
      }
    )
  },
  data () {
    return {
      selectedAnalyse: null,
      filters: [],
      selectedElement: null,
      element_type: null,
      element_id:null,
      element: null,
      programmation: null,
      viewProgrammation: null,
      fields: [
        {key:'index', label:'N°'},
        {key:'matricule', label:'Matricule'},
        {key:'patient',label: 'Patient'},
        {key: 'age',label:"Age"},
        {key: 'sexe',label: "Sexe" },
        {key: 'departement',label: "Département" },
        {key: 'poste',label: "Poste" },
        {key: 'is_done',label: "Statut" },
        {key: "actions",label:"Actions"}
      ]

    
    }
  },
  watch: {
    results() {
      this.results.forEach(()=> {
        let single_filter = {word: ""}
        this.filters.push(single_filter)
      });

    },
    selectedElement(){
      if(this.selectedElement ===null){
        this.element_type = null,
        this.element_id = null
      } else {
        this.element_type = this.selectedElement.type,
        this.element_id = this.selectedElement.id
      }
      
    }

  },
  computed: {
    user(){
      return this.$store.getters["authInfo"];
    },
    activeRole(){
      return this.$store.getters["activeRole"];
    },
    results(){
      return this.$store.getters["visiteMedicaleResults"]
    },
  },
  created(){
    this.$watch
    if(this.activeRole.nom == "ROLE_INFIRMIER_MEDECINE_TRAVAIL"){
      this.$store.dispatch("getVisitesProgrammationsInfirmier",{visite_id:this.$route.params.id,user_id:this.user.user.id}).then(
        () => {
          
        }
      )
    }else {
      this.$store.dispatch("getProgrammationsForTechLabo",this.$route.params.id).then(
        () => {
          
        }
      )
    }
    
    
  },
  mounted () {
    if(this.activeRole.nom == "ROLE_INFIRMIER_MEDECINE_TRAVAIL"){
      this.$store.dispatch("getVisitesProgrammationsInfirmier",{visite_id:this.$route.params.id,user_id:this.user.user.id}).then(
        () => {
          
        }
      )
    }else {
      this.$store.dispatch("getProgrammationsForTechLabo",this.$route.params.id).then(
        () => {
          
        }
      )
    }
    this.results.forEach(()=> {
      let single_filter = {word: ""}
      this.filters.push(single_filter)
    });
    if(this.selectedElement ===null){
      this.element_type = null,
      this.element_id = null
    } else {
      this.element_type = this.selectedElement.type,
      this.element_id = this.selectedElement.id
    }
    
  },
  methods: {
    selectRow(result,programmation){
      this.element = result,
      this.programmation = programmation
    },
    selectProgrammationToView(programmation){
      this.viewProgrammation = programmation
    },
    assignAnalyse(analyse){
      this.selectedAnalyse = {id: analyse.id, nom: analyse.nom}
    }
  }
}


